module.exports = __webpack_public_path__ + "static/img/logo.e6bb2d8a.jpg";